import cx from "classnames";
import HitsPerPage from "./HitsPerPage";
import {InformationCircleIcon, MapIcon, ViewListIcon} from "@heroicons/react/outline";
import {Hits, useHits} from "react-instantsearch-hooks-web";
import HorizontalHit from "./HorizontalHit";
import VerticalHit from "./VerticalHit";
import React, {useContext} from "react";
import FilterContext from "../Context/FilterContext";
import HitsStats from "./HitsStats";
import CustomPagination from "./CustomPagination";

const HitsList = props => {
    const { loading, mapView, setMapView } = useContext(FilterContext)
    const { hits } = useHits()

    return (
        <>
            <div className={'flex items-center justify-between'}>
                <HitsPerPage
                    items={[
                        { label: '10 résultats par page', value: 10 },
                        { label: '20 résultats par page', value: 20 },
                        { label: '50 résultats par page', value: 50, default: true },
                        { label: '100 résultats par page', value: 100 },
                    ]}
                />

                <div className={'bg-white shadow rounded-lg flex text-sm divide-x'}>
                    <button onClick={() => setMapView(!mapView)} className={'px-2 py-1 flex items-center gap-2'}>
                        {mapView ? <ViewListIcon className={'w-5 h-5 text-indigo-800'} /> : <MapIcon className={'w-5 h-5 text-indigo-800'} />}
                        <span className={'text-sm text-gray-600 tracking-wide'}>{mapView ? 'Liste' : 'Carte'}</span>
                    </button>
                </div>
            </div>

            <Hits hitComponent={mapView ? HorizontalHit : VerticalHit} classNames={{
                list: cx({'flex-grow flex flex-col gap-4': mapView, 'grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4': !mapView}),
                item: cx('hover:shadow-lg transition-shadow duration-500', {'p-2 bg-white rounded-lg shadow': !mapView})
            }}/>

            {
                hits.length > 0 ?
                    <>
                        <HitsStats />
                        <CustomPagination />
                    </> :
                    !loading ?
                    <div className={'p-4 rounded-lg shadow flex items-center gap-4 tracking-wide bg-white'}>
                        <InformationCircleIcon className={'w-8 h-8 text-indigo-800'} />
                        <div>
                            <p className={'text-gray-600'}>Pas de résultats pour cette recherche.</p>
                            <p className={'text-gray-400 text-sm'}>Ajustez vos filtres ou déplacez la carte et cliquez sur le bouton "Relancer la recherche ici"</p>
                        </div>
                    </div> :
                null
            }
        </>
    )
}

export default HitsList